// Functional CSS
// ... more spacing constants
export const SPACING_NONE = '0';
export const SPACING_EXTS1 = '0.0625rem'; //1px
export const SPACING_EXTS2 = '0.125rem'; // 2px
export const SPACING_XXS = '0.150rem';
export const SPACING_XS = '0.500rem';
export const SPACING_S = '0.625rem';
export const SPACING_M = '1.250rem'; //20px
export const SPACING_L = '2.500rem'; //40px
export const SPACING_L1 = '2.625rem'; //42px
export const SPACING_LS = '3.125rem'; //50px
export const SPACING_XL = '3.750rem'; //60px
export const SPACING_XXL = '4.125rem'; //66px

export const FONTSIZE_XXS = '0.750rem'; //12px
export const FONTSIZE_XS = '0.813rem'; //13px
export const FONTSIZE_XSS = '0.875rem'; //13px
export const FONTSIZE_S = '0.938rem'; //15px
export const FONTSIZE_M = '1.063rem'; //17px
export const FONTSIZE_MS = '1.125rem'; //18px
export const FONTSIZE_L = '1.250rem'; //20px
export const FONTSIZE_LS = '1.500rem'; //24px
export const FONTSIZE_XL = '1.875rem'; //30px
export const FONTSIZE_XLS = '2.250rem'; //36px
export const FONTSIZE_XLM = '2.500rem'; //40px
export const FONTSIZE_XLL = '3.125rem'; //50px
export const FONTSIZE_XXL = '4rem'; //50px

// ... more colour constants
export const COLOR_VERY_LIGHT_GRAYISH_BLUE = '#f4f6f9';
export const COLOR_LIGHT_GRAYISH_BLUE = '#eef0f2';
export const COLOR_DARK_GRAYISH_BLUE = '#a0aab1';
export const COLOR_VERY_DARK_GRAYISH_BLUE = '#425563';
export const COLOR_DESATURATED_DARK_BLUE = '#566676';
export const COLOR_DARK_CYAN = '#01a982';
export const COLOR_BLACK = '#000000';
export const COLOR_WHITE = '#ffffff';
export const COLOR_VERY_LIGHT_GRAY = '#fafafa';
export const COLOR_LIGHT_GRAY = '#ccc';
export const COLOR_DARK_GRAY = '#757575';
export const COLOR_VERY_DARK_GRAY = '#444444';
export const COLOR_MODERATE_RED = '#d3524d';
export const COLOR_BRIGHT_ORANGE = '#fc9935';
export const COLOR_STRONG_CYAN = '#2ad2c9';
export const COLOR_DARK_MODERATE_MAGENTA = '#7a2b8a';
export const COLOR_LIGHT_DARK_BLUE = '#1973cb';

export default {
  // ... colors
  COLOR_LIGHT_GRAY,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_LIGHT_DARK_BLUE,
  veryLightGrayishBlue: { color: COLOR_VERY_LIGHT_GRAYISH_BLUE },
  lightGrayishBlue: { color: COLOR_LIGHT_GRAYISH_BLUE },
  darkGrayishBlue: { color: COLOR_DARK_GRAYISH_BLUE },
  veryDarkGrayishBlue: { color: COLOR_VERY_DARK_GRAYISH_BLUE },
  desaturatedDarkBlue: { color: COLOR_DESATURATED_DARK_BLUE },
  darkCyan: { color: COLOR_DARK_CYAN },
  strongCyan: { color: COLOR_STRONG_CYAN },
  black: { color: COLOR_BLACK },
  white: { color: COLOR_WHITE },
  veryLightGray: { color: COLOR_VERY_LIGHT_GRAY },
  lightGray: { color: COLOR_LIGHT_GRAY },
  darkGray: { color: COLOR_DARK_GRAY },
  veryDarkGray: { color: COLOR_VERY_DARK_GRAY },
  moderateRed: { color: COLOR_MODERATE_RED },
  brightOrange: { color: COLOR_BRIGHT_ORANGE },
  darkModerateMagenta: { color: COLOR_DARK_MODERATE_MAGENTA },
  lightDarkBlue: { color: COLOR_LIGHT_DARK_BLUE },

  // ... background colors
  bgVeryLightGrayishBlue: { backgroundColor: COLOR_VERY_LIGHT_GRAYISH_BLUE },
  bgLightGrayishBlue: { backgroundColor: COLOR_LIGHT_GRAYISH_BLUE },
  bgDarkGrayishBlue: { backgroundColor: COLOR_DARK_GRAYISH_BLUE },
  bgVeryDarkGrayishBlue: { backgroundColor: COLOR_VERY_DARK_GRAYISH_BLUE },
  bgDarkCyan: { backgroundColor: COLOR_DARK_CYAN },
  bgStrongCyan: { backgroundColor: COLOR_STRONG_CYAN },
  bgBlack: { backgroundColor: COLOR_BLACK },
  bgWhite: { backgroundColor: COLOR_WHITE },
  bgVeryLightGray: { backgroundColor: COLOR_VERY_LIGHT_GRAY },
  bgLightGray: { backgroundColor: COLOR_LIGHT_GRAY },
  bgDarkGray: { backgroundColor: COLOR_DARK_GRAY },
  bgVeryDarkGray: { backgroundColor: COLOR_VERY_DARK_GRAY },
  bgModerateRed: { backgroundColor: COLOR_MODERATE_RED },
  bgBrightOrange: { backgroundColor: COLOR_BRIGHT_ORANGE },
  bgDarkModerateMagenta: { backgroundColor: COLOR_DARK_MODERATE_MAGENTA },

  // ... fontFamily
  fontFamilyMonospace: { fontFamily: 'arial' },

  // ... fontsize
  fontSize12: { fontSize: FONTSIZE_XXS },
  fontSize13: { fontSize: FONTSIZE_XS },
  fontSize14: { fontSize: FONTSIZE_XSS },
  fontSize15: { fontSize: FONTSIZE_S },
  fontSize17: { fontSize: FONTSIZE_M },
  fontSize18: { fontSize: FONTSIZE_MS },
  fontSize20: { fontSize: FONTSIZE_L },
  fontSize24: { fontSize: FONTSIZE_LS },
  fontSize30: { fontSize: FONTSIZE_XL },
  fontSize36: { fontSize: FONTSIZE_XLS },
  fontSize40: { fontSize: FONTSIZE_XLM },
  fontSize50: { fontSize: FONTSIZE_XLL },
  fontSize60: { fontSize: FONTSIZE_XXL },

  // ... Font Styles
  thin: { fontWeight: '100' }, // Thin
  ultraLight: { fontWeight: '200' }, // Ultra Light
  light: { fontWeight: '300' }, // Light
  regular: { fontWeight: '400' }, // Regular
  medium: { fontWeight: '500' }, // Medium
  semiBold: { fontWeight: '600' }, // Semibold
  bold: { fontWeight: '700' }, // Bold
  heavy: { fontWeight: '800' }, // Heavy
  dark: { fontWeight: '900' }, // Dark
  lineHeight20: { lineHeight: 20 },
  lineHeight25: { lineHeight: 25 },

  // ... margin: spacing
  margin0: { margin: SPACING_NONE },
  margin1: { margin: SPACING_XXS },
  margin2: { margin: SPACING_XS },
  margin3: { margin: SPACING_S },
  margin4: { margin: SPACING_M },
  margin5: { margin: SPACING_L },
  margin6: { margin: SPACING_LS },
  margin7: { margin: SPACING_XL },

  marginTop0: { marginTop: SPACING_NONE },
  marginTop1: { marginTop: SPACING_XXS },
  marginTop2: { marginTop: SPACING_XS },
  marginTop3: { marginTop: SPACING_S },
  marginTop4: { marginTop: SPACING_M },
  marginTop5: { marginTop: SPACING_L },
  marginTop6: { marginTop: SPACING_LS },
  marginTop7: { marginTop: SPACING_XL },

  marginLeft0: { marginLeft: SPACING_NONE },
  marginLeft1: { marginLeft: SPACING_XXS },
  marginLeft2: { marginLeft: SPACING_XS },
  marginLeft3: { marginLeft: SPACING_S },
  marginLeft4: { marginLeft: SPACING_M },
  marginLeft5: { marginLeft: SPACING_L },
  marginLeft6: { marginLeft: SPACING_LS },
  marginLeft7: { marginLeft: SPACING_XL },

  marginRight0: { marginRight: SPACING_NONE },
  marginRight1: { marginRight: SPACING_XXS },
  marginRight2: { marginRight: SPACING_XS },
  marginRight3: { marginRight: SPACING_S },
  marginRight4: { marginRight: SPACING_M },
  marginRight5: { marginRight: SPACING_L },
  marginRight6: { marginRight: SPACING_LS },
  marginRight7: { marginRight: SPACING_XL },

  marginBottom0: { marginBottom: SPACING_NONE },
  marginBottom1: { marginBottom: SPACING_XXS },
  marginBottom2: { marginBottom: SPACING_XS },
  marginBottom3: { marginBottom: SPACING_S },
  marginBottom4: { marginBottom: SPACING_M },
  marginBottom5: { marginBottom: SPACING_L },
  marginBottom6: { marginBottom: SPACING_LS },
  marginBottom7: { marginBottom: SPACING_XL },
  marginBottom8: { marginBottom: SPACING_XXL },

  marginBottom30px: { marginBottom: '30px' },

  marginHorizontal0: { marginLeft: SPACING_NONE, marginRight: SPACING_NONE },
  marginHorizontal1: { marginLeft: SPACING_XXS, marginRight: SPACING_XXS },
  marginHorizontal2: { marginLeft: SPACING_XS, marginRight: SPACING_XS },
  marginHorizontal3: { marginLeft: SPACING_S, marginRight: SPACING_S },
  marginHorizontal4: { marginLeft: SPACING_M, marginRight: SPACING_M },
  marginHorizontal5: { marginLeft: SPACING_L, marginRight: SPACING_L },
  marginHorizontal6: { marginLeft: SPACING_LS, marginRight: SPACING_LS },
  marginHorizontal7: { marginLeft: SPACING_XL, marginRight: SPACING_XL },

  marginVertical0: { marginTop: SPACING_NONE, marginBottom: SPACING_NONE },
  marginVertical1: { marginTop: SPACING_XXS, marginBottom: SPACING_XXS },
  marginVertical2: { marginTop: SPACING_XS, marginBottom: SPACING_XS },
  marginVertical3: { marginTop: SPACING_S, marginBottom: SPACING_S },
  marginVertical4: { marginTop: SPACING_M, marginBottom: SPACING_M },
  marginVertical5: { marginTop: SPACING_L, marginBottom: SPACING_L },
  marginVertical6: { marginTop: SPACING_LS, marginBottom: SPACING_LS },
  marginVertical7: { marginTop: SPACING_XL, marginBottom: SPACING_XL },

  // ... padding: spacing properties
  padding0: { padding: SPACING_NONE },
  padding1: { padding: SPACING_XXS },
  padding2: { padding: SPACING_XS },
  padding3: { padding: SPACING_S },
  padding4: { padding: SPACING_M },
  padding5: { padding: SPACING_L },
  padding6: { padding: SPACING_LS },
  padding7: { padding: SPACING_XL },

  paddingTop0: { paddingTop: SPACING_NONE },
  paddingTop1: { paddingTop: SPACING_XXS },
  paddingTop2: { paddingTop: SPACING_XS },
  paddingTop3: { paddingTop: SPACING_S },
  paddingTop4: { paddingTop: SPACING_M },
  paddingTop5: { paddingTop: SPACING_L },
  paddingTop6: { paddingTop: SPACING_LS },
  paddingTop7: { paddingTop: SPACING_XL },

  paddingBottom0: { paddingBottom: SPACING_NONE },
  paddingBottom1: { paddingBottom: SPACING_XXS },
  paddingBottom2: { paddingBottom: SPACING_XS },
  paddingBottom3: { paddingBottom: SPACING_S },
  paddingBottom4: { paddingBottom: SPACING_M },
  paddingBottom5: { paddingBottom: SPACING_L },
  paddingBottom6: { paddingBottom: SPACING_LS },
  paddingBottom7: { paddingBottom: SPACING_XL },

  paddingRight0: { paddingRight: SPACING_NONE },
  paddingRight1: { paddingRight: SPACING_XXS },
  paddingRight2: { paddingRight: SPACING_XS },
  paddingRight3: { paddingRight: SPACING_S },
  paddingRight4: { paddingRight: SPACING_M },
  paddingRight5: { paddingRight: SPACING_L },
  paddingRight6: { paddingRight: SPACING_LS },
  paddingRight7: { paddingRight: SPACING_XL },

  paddingLeft0: { paddingLeft: SPACING_NONE },
  paddingLeft1: { paddingLeft: SPACING_XXS },
  paddingLeft2: { paddingLeft: SPACING_XS },
  paddingLeft3: { paddingLeft: SPACING_S },
  paddingLeft4: { paddingLeft: SPACING_M },
  paddingLeft5: { paddingLeft: SPACING_L },
  paddingLeft6: { paddingLeft: SPACING_LS },
  paddingLeft7: { paddingLeft: SPACING_XL },

  paddingHorizontal0: { paddingLeft: SPACING_NONE, paddingRight: SPACING_NONE },
  paddingHorizontal1: { paddingLeft: SPACING_XXS, paddingRight: SPACING_XXS },
  paddingHorizontal2: { paddingLeft: SPACING_XS, paddingRight: SPACING_XS },
  paddingHorizontal3: { paddingLeft: SPACING_S, paddingRight: SPACING_S },
  paddingHorizontal4: { paddingLeft: SPACING_M, paddingRight: SPACING_M },
  paddingHorizontal5: { paddingLeft: SPACING_L, paddingRight: SPACING_L },
  paddingHorizontal6: { paddingLeft: SPACING_LS, paddingRight: SPACING_LS },
  paddingHorizontal7: { paddingLeft: SPACING_XL, paddingRight: SPACING_XL },

  paddingVertical0: { paddingTop: SPACING_NONE, paddingBottom: SPACING_NONE },
  paddingVertical1: { paddingTop: SPACING_XXS, paddingBottom: SPACING_XXS },
  paddingVertical2: { paddingTop: SPACING_XS, paddingBottom: SPACING_XS },
  paddingVertical3: { paddingTop: SPACING_S, paddingBottom: SPACING_S },
  paddingVertical4: { paddingTop: SPACING_M, paddingBottom: SPACING_M },
  paddingVertical5: { paddingTop: SPACING_L, paddingBottom: SPACING_L },
  paddingVertical6: { paddingTop: SPACING_LS, paddingBottom: SPACING_LS },
  paddingVertical7: { paddingTop: SPACING_XL, paddingBottom: SPACING_XL },

  // ... flex properties
  flex0: { flex: 0 },
  flex1: { flex: 1 },
  flex2: { flex: 2 },
  flex3: { flex: 3 },
  flexRow: { flexDirection: 'row' },
  flexColumn: { flexDirection: 'column' }, // column is set to default in react
  flexWrap: { flexWrap: 'wrap' },

  // ...
  itemsStart: { alignItems: 'flex-start' },
  itemsEnd: { alignItems: 'flex-end' },
  itemsCenter: { alignItems: 'center' },
  itemsBaseline: { alignItems: 'baseline' },
  itemsStrech: { alignItems: 'stretch' },

  // ...
  selfStart: { alignSelf: 'flex-start' },
  selfEnd: { alignSelf: 'flex-end' },
  selfCenter: { alignSelf: 'center' },
  selfBaseline: { alignSelf: 'baseline' },
  selfStretch: { alignSelf: 'stretch' },

  // ...
  justifyStart: { justifyContent: 'flex-start' },
  justifyEnd: { justifyContent: 'flex-end' },
  justifyCenter: { justifyContent: 'center' },
  justifyBetween: { justifyContent: 'space-between' },
  justifyAround: { justifyContent: 'space-around' },

  // ...
  contentStart: { alignContent: 'flex-start' },
  contentEnd: { alignContent: 'flex-end' },
  contentCenter: { alignContent: 'center' },
  contentBetween: { alignContent: 'space-between' },
  contentAround: { alignContent: 'space-around' },
  contentAlign: { alignContent: 'stretch' },

  // ...
  center: { textAlign: 'center' },
  right: { textAlign: 'right' },
  left: { textAlign: 'left' }, // default

  width45: { width: '45%' },

  flexGrow: { flexGrow: 1 },

  lineHeightCompact: { lineHeight: '70%' },

  // ...
  noTextDecoration: { textDecoration: 'none' },
  noBorder: { borderWidth: 0 },
  noBorderBottom: { borderBottomWidth: 0 },
  o_100: { opacity: 1 },
  o_50: { opacity: 0.5 },
  primaryButton: {
    backgroundColor: '#01a982',
    borderWidth: 0,
  },

  // -----------------------
  // For content, top to bottom:
  mainContainerStyle: {
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
    cursor: 'auto',
  },

  pageWrapper: {
    width: '100%',
    height: '100%',
    minHeight: 'calc(100vh - 72px)',
  },

  welcomeCenterLeftNav: {
    minWidth: '17.5rem',
    minHeight: 'calc(100vh - 72px)',
    borderRight: '1px solid #e6e6e6',
  },

  welcomeCenterContent: {
    maxWidth: '920px',
    border: 'none',
  },

  content: {
    minHeight: 'calc(100vh - 221px)',
    overflow: 'auto',
  },

  pageNavBar: {
    marginTop: '20px',
    marginBottom: '80px',
  },

  offset: {
    marginLeft: '20px',
    marginRight: '20px',
  },

  // -----------------------
  // For Mobile view
  overlayStyle: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    opacity: 0.2,
    backgroundColor: '#000',
    zIndex: 100,
  },

  sideMenuStyle: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '-280px',
    width: '280px',
    height: '100%',
    minHeight: 'calc(100vh - 72px)',
    background: '#fff',
    zIndex: 150,
    transition: '1s',
    borderRight: '1px solid #e6e6e6',
  },

  surveyLinkTextClass: {
    fontWeight: 'bold',
    fontSize: FONTSIZE_L,
    color: COLOR_BLACK,
    backgroundColor: COLOR_WHITE,
    padding: '15px',
    borderRadius: '25px',
  },

  surveyLinkClass: {
    border: `3px solid ${COLOR_DARK_CYAN}`,
    display: 'inline-block',
    height: '8px',
    width: '50px',
    marginLeft: '10px',
    position: 'relative',
    top: '1px',
  },
};
